import strUtils from '@/js/strUtils'

const createProxyOpt = async (target, proxyInfo, isSilent) => {
    let opt = ""
    // 対話型の時は、コマンド実行中に入力
    if (!isSilent) {
        return ""
    }
    if (proxyInfo.address && proxyInfo.port) {
        opt += ` --${target}_proxy_address ${proxyInfo.address}`
        opt += ` --${target}_proxy_port ${proxyInfo.port}`
        if (proxyInfo.account && proxyInfo.password) {
            opt += ` --${target}_proxy_account ${proxyInfo.account}`
            opt += ` --${target}_proxy_password ${proxyInfo.password}`
        }
        if (target === "test" && proxyInfo.url) {
            opt += ` --${target}_proxy_url ${proxyInfo.url}`
        }
    }
    return opt
}

const isNeedQtOpt = async (qtInfo) => {
    return qtInfo.workspace && qtInfo.apiKey && qtInfo.tdashTestrun && qtInfo.qtProject
}

const createQtOpt = async (qtInfo) => {
    // 必須
    let qtOpt = ` --qt_workspace ${qtInfo.workspace} --qt_api ${qtInfo.apiKey}`;
    qtOpt += ` --qt_testrun ${qtInfo.tdashTestrun}`
    qtOpt += ` --qt_project ${qtInfo.qtProject}`

    // 任意
    if (qtInfo.usePreviousTestrun) {
        qtOpt += " --qt_use_previous_testrun"
    }

    if (qtInfo.startDate !== "") {
        const startDate = await strUtils.replaceHyphen(qtInfo.startDate)
        qtOpt += ` --qt_scheduled_start_date ${startDate}`
    }

    if (qtInfo.endDate !== "") {
        const endDate = await strUtils.replaceHyphen(qtInfo.endDate)
        qtOpt += ` --qt_scheduled_end_date ${endDate}`
    }
    return qtOpt
}

const isNeedAnyTestOpt = async (anytestInfo) => {
    return anytestInfo.user && anytestInfo.apiKey && anytestInfo.deviceId > 0
}

const createAnyTestOpt = async (anytestInfo) => {

    // 必須
    let anytestOpt = ` --anytest_user ${anytestInfo.user} --anytest_key ${anytestInfo.apiKey}`

    if (anytestInfo.deviceId > 0) {
        anytestOpt += ` --anytest_device ${anytestInfo.deviceId}`
    }

    // 任意
    if (anytestInfo.runTime >= 5) {
        anytestOpt += ` --anytest_runtime ${anytestInfo.runTime}`
    }
    return anytestOpt
}

export default {
    createProxyOpt,
    isNeedQtOpt,
    createQtOpt,
    isNeedAnyTestOpt,
    createAnyTestOpt,
}
